import React, { useContext, useEffect } from 'react';
import { UserContext } from '@incentivegames/ig-frontend-common/lib/contexts/userContext';
import { devTools } from '../../common/devtools';
import { useGetEntry } from '../../store/entry/entryActions';
import { useGetEvents } from '../../store/event/eventActions';
import { usePredictorStore } from '../../store/predictor/predictorStore';
import { isFail } from '../../common/serviceUtil';
import { useEventStore } from '../../store/event/eventStore';
import InPlayController from '../InPlayController/InPlayController';
import PrePlayController from '../PrePlayController/PrePlayController';
import LoadingScreen from '../../components/Screens/LoadingScreen/LoadingScreen';
import Error from '../../components/Error/Error';
import { useEntryStore } from '../../store/entry/entryStore';

const PredictorController = () => {
  const { user, setCurrency } = useContext(UserContext);
  const entry = useEntryStore((s) => s.entry);
  const userToken = user.token;
  devTools.log('using userToken', userToken);

  const predictor = usePredictorStore((s) => s.activePredictor);
  const { status: entryStatus, data: entryData } = useGetEntry({ userToken, predictorId: predictor?.predictorId });
  const { status: eventStatus, data: eventData } = useGetEvents(predictor?.eventGroupId, predictor?.marketCode);
  const inPlay = useEventStore((s) => s.inPlay);

  const isLoading = entryStatus === 'loading' || eventStatus === 'loading';
  const isError = isFail(entryData) || isFail(eventData) || entryStatus === 'error' || eventStatus === 'error';

  useEffect(() => {
    //make sure we are using the currency from the entry
    if (!entry?.currencyCode || user.currency === entry.currencyCode) return;
    setCurrency(entry?.currencyCode);
  }, [entry?.currencyCode, setCurrency, user.currency]);

  if (isLoading) return <LoadingScreen />;
  if (isError) return <Error />;

  return inPlay ? <InPlayController /> : <PrePlayController />;
};
export default PredictorController;
